const getSelectedTradeMedicData = state => state.modal.selectedTradeMedicData;

export default getSelectedTradeMedicData;